import * as portableFetch from "portable-fetch";
import * as generated from "./generated/api";
import * as remote from "./api-wrapper-remote";

export * from "./generated/api"

export const destinationsApi: generated.DestinationsApi =
    new remote.DestinationsApi(portableFetch, config.endpoint).initialize();
export const myTripsApi: generated.MyTripsApi =
    new remote.MyTripsApi(portableFetch, config.endpoint).initialize();
export const myTripChecklistApi: generated.MyTripChecklistApi =
    new remote.MyTripChecklistApi(portableFetch, config.endpoint).initialize();
export const publicApi: generated.PublicApi =
    new remote.PublicApi(portableFetch, config.endpoint).initialize();
export const emarsysApi: generated.EmarsysApi =
    new remote.EmarsysApi(portableFetch, config.endpoint).initialize();
export const myTripPicturesApi : generated.MyTripPicturesApi =
    new remote.MyTripPicturesApi(portableFetch, config.endpoint).initialize();
export const translationsApi : generated.TranslationApi =
    new remote.TranslationsApi(portableFetch, config.endpoint).initialize();
export const travelAppConfigApi : generated.TravelAppConfigApi =
    new remote.TravelAppConfigApi(portableFetch, config.endpoint).initialize();
export const myTripNotificationsApi: generated.MyTripNotificationsApi =
    new remote.MyTripNotificationsApi(portableFetch, config.endpoint).initialize();
export const myTripParticipantsApi: generated.MyTripParticipantsApi =
    new remote.MyTripParticipantsApi(portableFetch, config.endpoint).initialize();
